import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// 场地清单-地图模式数据
interface PlaceListMapInfoProps {
  searchParams?: { cityId?: number|string, fieldTypeId?: number|string } | null // 筛选条件
  filterCity?: number | string | null, // 筛选条件-城市
  mapData?: any[], // 地图搜索数据（关键词搜索出来的地图数据）
  selectedPlaceData?: any, // 当前选择的场地信息
  // 高德地图搜索出的选中的地点信息
  amapLocationInfo: null | {
    source: string,
    key: string | number,
    name: string,
    address: string,
    lng: string | number,
    lat: string | number,
  }
}

interface InitStataProps {
  number: number;
  placeListMapInfo: PlaceListMapInfoProps; // 场地清单-地图模式数据
}

// 获取原始数据
const getOriPlaceListMapInfo = (): PlaceListMapInfoProps => ({
  searchParams: null, // 筛选条件
  filterCity: null, // 筛选条件-城市
  /* 地图搜索数据（关键词搜索出来的地图数据）
  [{
    "key": "Hair 1",
    "source": "amap",
    "name": "Hair 1",
    "address": "圣十字径41号",
    "lng": 114.226954,
    "lat": 22.278586
  }] */
  mapData: [],
  /* 当前选择的场地信息
  {
    "source": "place",
    "name": "杭州西溪八方城",
    "key": 2078,
    "city": "杭州市",
    "address": "杭州市余杭区",
    "lng": "120.046083",
    "lat": "30.289958"
  }
 */
  selectedPlaceData: null,
  amapLocationInfo: null, // 高德地图搜索出的选中的地点信息
});

/**
 * @demo
import { resetPlaceListMapInfo } from 'src/views/open/store/index';
import { useSelector, useDispatch } from 'react-redux';

  const placeListMapInfo = useSelector((state: any) => state.open.placeListMapInfo);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetPlaceListMapInfo());
  }, []);
 */
const initialState: InitStataProps = {
  number: 0,
  /* 场地清单-地图模式 start */
  // 场地清单-地图模式数据，不能为 null
  placeListMapInfo: getOriPlaceListMapInfo(),
  /* 场地清单-地图模式 end */
};
const customerSlice = createSlice({
  name: 'open',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
    /* 场地清单-地图模式 start */
    // 重置 placeListMapInfo
    resetPlaceListMapInfo(state = initialState) {
      state.placeListMapInfo = getOriPlaceListMapInfo();
    },
    // 更新筛选条件
    updateSearchParams: (state = initialState, action: PayloadAction<any>) => {
      // console.log('action.payload', action.payload);
      state.placeListMapInfo.searchParams = action.payload;
    },
    // 筛选条件-城市
    updateFilterCity: (state = initialState, action: PayloadAction<any>) => {
      state.placeListMapInfo.filterCity = action.payload;
    },
    // 更新通过关键词搜索出来的地图数据
    updateMapData: (state = initialState, action: PayloadAction<any[]>) => {
      state.placeListMapInfo.mapData = action.payload;
    },
    // 更新选择的场地信息
    updateSelectedPlaceData: (state = initialState, action: PayloadAction<any>) => {
      state.placeListMapInfo.selectedPlaceData = action.payload;
    },
    // 更新高德地图地点信息
    updateAmapLocationInfo: (state = initialState, action: PayloadAction<any>) => {
      state.placeListMapInfo.amapLocationInfo = action.payload;
    },
    /* 场地清单-地图模式 end */
  },
});

// 导出action
export const {
  changeCount,
  resetPlaceListMapInfo, updateSearchParams, updateFilterCity, updateMapData, updateSelectedPlaceData, updateAmapLocationInfo
} = customerSlice.actions;

export default customerSlice.reducer;
